<script lang="ts">import { stateTheme, Theme } from "@infinitro/config";
import SealFlush from "./seal-flush.svelte";
import SealRocket from "./seal-rocket.svelte";
import SealTurbo from "./seal-turbo.svelte";
</script>

{#if $stateTheme === Theme.Rocketbet}
	<SealRocket />
{:else if $stateTheme === Theme.Turboslots}
	<SealTurbo />
{:else}
	<SealFlush />
{/if}
